import { toNumber } from './Utils';

type AmountLike = {
  amount?: {
    currency_code?: string;
    value?: unknown;
  };
};

/** Sum product amounts by local currency vs USD without mixing other codes into either bucket. */
export function sumApplicationTotalsByCurrency(
  products: AmountLike[],
  localCurrencyCode: string,
  usdCurrencyCode: string
): { local: number; usd: number } {
  let local = 0;
  let usd = 0;

  products.forEach((product) => {
    const amount = toNumber(product.amount?.value as any) || 0;
    const code = product.amount?.currency_code;
    if (code === localCurrencyCode) {
      local += amount;
    } else if (code === usdCurrencyCode) {
      usd += amount;
    }
  });

  return { local, usd };
}
